// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2e853fcd","355":"6bccd4a1","667":"6ac978ec","977":"847d482c"}[chunkId] + ".chunk.js";
};